"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TimeClock = function TimeClock(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: "0.9"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "md-time",
    fill: "#000000"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.99423077,0 C2.68269231,0 0,2.68846154 0,6 C0,9.31153846 2.68269231,12 5.99423077,12 C9.31153846,12 12,9.31153846 12,6 C12,2.68846154 9.31153846,0 5.99423077,0 Z M6,10.8 C3.34903846,10.8 1.2,8.65096154 1.2,6 C1.2,3.34903846 3.34903846,1.2 6,1.2 C8.65096154,1.2 10.8,3.34903846 10.8,6 C10.8,8.65096154 8.65096154,10.8 6,10.8 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Path",
    points: "6.3 3 5.4 3 5.4 6.6 8.55 8.48942308 9 7.75096154 6.3 6.15"
  }))));
};

var _default = TimeClock;
exports["default"] = _default;